import { render, staticRenderFns } from "./Product-public.vue?vue&type=template&id=7b65fd65&scoped=true&lang=pug"
import script from "./Product-public.vue?vue&type=script&lang=js"
export * from "./Product-public.vue?vue&type=script&lang=js"
import style0 from "./Product-public.vue?vue&type=style&index=0&id=7b65fd65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65fd65",
  null
  
)

export default component.exports